module.exports = __webpack_public_path__ + "img/schedule-empty.659ba84a.png";